import {post} from '@/utils/request';
import {erpplatserver} from '@/utils/baseUrl';

//登录
export async function getlogin(params) {
    return post(erpplatserver+'/login/validate', params, true);
    // return post('http://test.m.ghwline.com/login/validate', params, true);

}
//获取验证码
export async function sendVerficationCode(params) {
    return post(erpplatserver+'/login/sendVerficationCode', params, true)
}
//设置密码
export async function setpwd(params) {
    return post(erpplatserver+'/login/setPwd', params, true)
}
//验证码success
export async function validateCode(params) {
    return post(erpplatserver+'/login/validateCode', params, true)
}